import React from "react";
import Script from "next/script";
import { END } from "redux-saga";
import { wrapper } from "@/store";
import { connect } from "react-redux";
import {
  getStaticProps as getStaticPropsMethod,
  getStaticPaths as getStaticPathsMethod,
} from "@gc-npm/astro/astro-pages-handler";

import { actions as headerActions } from "@gc-npm/reducers.header-reducer";
import { actions as uiActions } from "@/reducers/ui";
import { actions as devicesActions } from "@/reducers/devices";
import { actions as clientActions } from "@/reducers/client";
import MetaData from "@gc-npm/core.meta-data";
import Footer from "@gc-npm/components.footer";
import Header from "@gc-npm/components.header-isr";
import { LAYOUT_TYPES, SCREEN_TYPES } from "@/utils/constants";
import Configurador from "@/components/Configurador";
import AutoSelection from "@/components/AutoSelection";
import Confirmation from "@/components/Confirmation";
import Tapon from "@/components/Tapon";
import ToolTip from "@/components/ToolTip";
import DevicesSlider from "@/components/DevicesSlider";
import BouncingLogo from "@/components/BouncingLogo";
import SeparatorLine from "@/components/SeparatorLine";
import getUrlParams from "@gc-npm/utils.common.get-url-params";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      waitingLogoState:
        this.props.version === "bouncingstate" || this.props.UI?.bouncingLogo,
    };
  }

  componentDidUpdate(prevProps) {
    const { main, getLoginType, initializeConfig, UI } = this.props;
    const prevBouncingLogo = prevProps.UI?.bouncingLogo;
    const currentBouncingLogo = this.props.UI?.bouncingLogo;

    if (
      prevBouncingLogo !== currentBouncingLogo &&
      this.state.waitingLogoState !== currentBouncingLogo
    ) {
      this.setState({
        waitingLogoState: currentBouncingLogo,
      });
    }
    if (prevProps.main?.logged !== main?.logged) {
      const logged = main?.logged;

      if (logged !== 0) {
        if (typeof document !== "undefined") {
          getLoginType({ document });
        }
        initializeConfig();
      } else {
        this.setState({
          waitingLogoState: currentBouncingLogo || false,
        });
      }
    }
  }

  render() {
    const {
      breadcrumbsProps,
      headerProps,
      UI,
      seoInfo,
      footerProps,
      setRecaptcha,
      loggedStatus,
    } = this.props;

    const {
      layout,
      screenType,
      autoSelection,
      confirmation,
      tapon,
      notification,
      bouncingLogo,
    } = UI || {};
    const { waitingLogoState } = this.state;

    return (
      <>
        <Script
          src={`https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_LAYER_RECAPTCHA_ID}`}
          strategy="lazyOnload"
          onReady={() => {
            setRecaptcha(true);
          }}
        />
        <MetaData seoInfo={seoInfo} />
        <Header
          {...headerProps}
          {...breadcrumbsProps}
          loggedStatus={loggedStatus}
        />
        {tapon && <Tapon {...tapon} />}
        {!tapon && waitingLogoState && (
          <div className="bouncingLogo">
            <BouncingLogo />
          </div>
        )}
        {!waitingLogoState && !tapon && confirmation && <Confirmation />}
        {!waitingLogoState && !tapon && !confirmation && <Configurador />}

        {!waitingLogoState && notification && (
          <ToolTip notification={notification} />
        )}
        {!waitingLogoState && autoSelection && (
          <AutoSelection {...autoSelection} />
        )}
        {!waitingLogoState && (
          <>
            <div className="finalSticky" />
            <div className="Configurador_Extras">
              {layout !== LAYOUT_TYPES.TV && (
                <section className="Configurador_Extras-Devices">
                  <SeparatorLine />
                  <div className="Configurador_Extras-Devices__wrapper container">
                    <DevicesSlider />
                  </div>
                </section>
              )}
            </div>
          </>
        )}

        {screenType !== SCREEN_TYPES.MOBILE && footerProps && (
          <Footer footerProps={footerProps} />
        )}
        {screenType === SCREEN_TYPES.MOBILE && (
          <div className="configEnd" style={{ minHeight: "74px" }} />
        )}
        <style jsx>
          {`
            .Configurador {
              &_Extras {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                margin-top: 0.5rem;
                margin-bottom: 1rem;
                &-Devices {
                  display: flex;
                  flex-direction: column;
                  gap: 1rem;
                }
              }
            }
            .bouncingLogo {
              min-height: 100dvh;
              display: flex;
              align-content: center;
              flex-direction: column;
            }
            .finalSticky {
              margin-bottom: 1rem;
            }
          `}
        </style>
        <style jsx global>
          {`
            html {
              scrollbar-gutter: stable;
            }
            .Sticky {
              width: 100%;
            }
          `}
        </style>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  main: state.main,
  UI: state.UI,
  statusRecom: state.recomendator?.status?.init,
  statusModulos: state.modulos?.statusModulos,
});

const mapDispatchToProps = (dispatch) => ({
  initializeConfig: (data) => dispatch(uiActions.initializeConfig(data)),
  setRecaptcha: (data) => dispatch(uiActions.setRecaptcha(data)),
  getLoginType: (data) => dispatch(clientActions.getLoginType(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);

const ASTRO_ROUTE_BASE_PATH = "/fibra-y-movil/configurador";
const shouldPreloadBuildData = () => process.platform !== "win32";

export const getStaticPaths = async () =>
  getStaticPathsMethod({
    routeBasePath: ASTRO_ROUTE_BASE_PATH,
    repoId: process.platform === "win32" ? "" : undefined,
    fallback: "blocking",
    includeVersionContextVariants: false,
  });

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
  const isNotProd = currentEnv !== "prod" && currentEnv !== "preprod";
  const isQa = currentEnv === "qa_ssr";
  const isDev = currentEnv === "dev_ssr";
  const { store } = data;
  data.params = data.params || { slug: [] };

  const headerLocation = "/fibra-y-movil/configurador";

  const info = await getStaticPropsMethod(data, {
    routeBasePath: ASTRO_ROUTE_BASE_PATH,
  });
  console.log("INFORMATION !!!! \n\n", { info });
  const allProps2Return = {
    props: info.props,
    revalidate: info.revalidate || 300,
  };
  const { headerProps } = allProps2Return?.props || {};

  store.dispatch(headerActions.setHeaderLocation(headerLocation));
  store.dispatch(headerActions.setupHeaderProps(headerProps));

  if (shouldPreloadBuildData()) {
    store.dispatch(
      uiActions.initializeConfig({
        build: true,
      })
    );
    // llamada dispositivos:
    store.dispatch(devicesActions.getDevices({ build: true }));

    store.dispatch(END);
    await store.sagaTask.toPromise();
  } else {
    store.dispatch(uiActions.setBouncingLogo(true));
  }

  let revalidate = 60;
  if (currentEnv === "prod") {
    revalidate = 300;
  }

  if (isNotProd && allProps2Return.revalidate) {
    delete allProps2Return.revalidate;
  }

  return allProps2Return;
});
